import React from 'react';

import { SVGComponentProps } from './svg.types';

const HustlerIconSVG = ({ size = '1em', wrapperClass, ...otherProps }: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <mask id="path-1-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 14C48 6.26801 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26C0 39.2548 10.7452 50 24 50C37.2548 50 48 39.2548 48 26V14Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 14C48 6.26801 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26C0 39.2548 10.7452 50 24 50C37.2548 50 48 39.2548 48 26V14Z"
          fill="#FFF4F3"
        />
        <path
          d="M14 3H34V-3H14V3ZM3 26V14H-3V26H3ZM24 47C12.402 47 3 37.598 3 26H-3C-3 40.9117 9.08831 53 24 53V47ZM45 26C45 37.598 35.598 47 24 47V53C38.9117 53 51 40.9117 51 26H45ZM45 14V26H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61116 -3 14H3C3 7.92487 7.92487 3 14 3V-3Z"
          fill="#FFD321"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M14 3H34V-3H14V3ZM3 26V14H-3V26H3ZM24 47C12.402 47 3 37.598 3 26H-3C-3 40.9117 9.08831 53 24 53V47ZM45 26C45 37.598 35.598 47 24 47V53C38.9117 53 51 40.9117 51 26H45ZM45 14V26H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61116 -3 14H3C3 7.92487 7.92487 3 14 3V-3Z"
          fill="#F99386"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M16.4853 15.9041C16.3187 15.8788 16.0751 15.8609 15.7922 15.9041C14.7707 16.0603 14.1845 16.8799 14.0258 17.1016C13.1865 18.2723 13.4993 19.6781 13.6234 20.2374C13.944 21.6759 14.7927 22.5982 15.3836 23.2245C16.974 24.91 18.8945 25.6835 20.1219 26.0465L21.3335 27.4984C20.5619 27.3913 19.4288 27.1637 18.1543 26.6385C17.271 26.2741 15.6052 25.5675 14.1311 23.9564C13.5087 23.2766 12.6051 22.265 12.2216 20.6837C12.055 20.0098 11.6731 18.4047 12.5941 16.8398C12.7968 16.4932 13.4773 15.376 14.9058 14.8866C15.5502 14.6664 16.1254 14.6485 16.4884 14.6664C16.4868 15.0785 16.4868 15.492 16.4853 15.9041Z"
          fill="#F99386"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M31.5961 15.8937C31.7439 15.8773 31.9576 15.8654 32.2091 15.9041C33.229 16.0618 33.8199 16.8844 33.9755 17.1016C34.8147 18.2723 34.502 19.6781 34.3778 20.2374C34.0572 21.6759 33.2086 22.5982 32.6177 23.2245C31.0272 24.91 29.1084 25.6835 27.881 26.0465C27.4802 26.5062 27.0795 26.9658 26.6787 27.4255C27.4692 27.3377 28.5945 27.1384 29.8486 26.64C30.6218 26.3321 32.3489 25.6225 33.8718 23.9579C34.4941 23.2781 35.3978 22.2665 35.7812 20.6852C35.9447 20.0113 36.3266 18.4047 35.4072 16.8398C35.206 16.4976 34.5224 15.376 33.0954 14.8866C32.4967 14.6813 31.9592 14.653 31.6009 14.6619C31.5993 15.0725 31.5977 15.4831 31.5961 15.8937Z"
          fill="#F99386"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M16.5246 14H31.5504C31.6651 15.4534 31.6431 17.5241 30.9862 19.8924C29.9458 23.6426 27.8556 26.1819 26.6188 27.4701C26.6188 27.8941 26.6188 28.3181 26.6188 28.742C26.6078 28.806 26.5732 28.9637 26.4349 29.1035C26.2337 29.3058 25.9666 29.3148 25.9147 29.3148H25.1399V31.381C25.393 32.0252 25.8189 32.8909 26.5386 33.788C27.4203 34.8858 28.3852 35.5865 29.061 36H19.1318C19.7479 35.6073 20.6232 34.9498 21.4326 33.9367C22.2294 32.9385 22.6553 31.9761 22.8879 31.3141V29.3356C22.605 29.3356 22.3221 29.3356 22.0392 29.3356C21.9937 29.3341 21.7752 29.3252 21.596 29.1571C21.4279 28.9979 21.4106 28.8045 21.4075 28.7584C21.4075 28.3657 21.4075 27.9715 21.4075 27.5787C20.1628 26.2414 18.1103 23.6664 17.0872 19.9057C16.4445 17.5434 16.4162 15.4712 16.5246 14Z"
          fill="#F99386"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="50"
        >
          <mask id="path-6-inside-2" mask-type="luminance" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48 14C48 6.26802 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26.9231C0 39.6681 10.7452 50 24 50C37.2548 50 48 39.6681 48 26.9231V14Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 14C48 6.26802 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26.9231C0 39.6681 10.7452 50 24 50C37.2548 50 48 39.6681 48 26.9231V14Z"
            fill="#FFF3E5"
          />
          <path
            d="M14 3H34V-3H14V3ZM3 26.9231V14H-3V26.9231H3ZM24 47C12.29 47 3 37.9014 3 26.9231H-3C-3 41.4348 9.2003 53 24 53V47ZM45 26.9231C45 37.9014 35.71 47 24 47V53C38.7997 53 51 41.4348 51 26.9231H45ZM45 14V26.9231H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61115 -3 14H3C3 7.92486 7.92487 3 14 3V-3Z"
            fill="#EDC474"
            mask="url(#path-6-inside-2)"
          />
        </mask>
        <g mask="url(#mask0)">
          <rect
            opacity="0.2"
            x="-16"
            y="46"
            width="72"
            height="20"
            transform="rotate(-45 -16 48)"
            fill="white"
          />
        </g>
      </svg>
    </span>
  );
};

export default HustlerIconSVG;
